module.exports = __webpack_public_path__ + "images/porsche_smalldd662e281d94b8369f769b5153756ef9.png";